// extracted by mini-css-extract-plugin
module.exports = {"signInSettings":"SignInSettings_signInSettings__188fk","label":"SignInSettings_label__2Hw07","status":"SignInSettings_status__2uqk8"};